import clsx from "clsx";
import { twMerge } from "tailwind-merge";

export const wrapperClassNames =
  "mx-auto my-[0.4rem] max-w-screen-readable w-full relative";

export const getDraggingClassNames = (
  isOver: boolean,
  isInitial: boolean,
  rounded: "s" | "m" | "l" = "s",
) =>
  twMerge(
    clsx(
      "flex-1 max-w-full transition ease-out duration-200 border border-dashed bg-neutral-20 border-neutral-200",
      rounded === "s" && "rounded-small",
      rounded === "m" && "rounded",
      rounded === "l" && "rounded-large",
      isOver && "border-[1.5px] bg-blue-60 border-blue-460",
      isOver && !isInitial && "bg-blue-360 border-blue-560",
    ),
  );
